import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var MutationClass;
function Mutation() {
  if (MutationClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Mutation');
    MutationClass = $;
  }
  return MutationClass;
}
//region block: exports
export {
  Mutation as Mutationkenyz0l5btz,
};
//endregion

//# sourceMappingURL=Mutation.mjs.map
